<script>
import { useEnvStore } from "@dutypay/store-modules";
//import { to } from "await-to-js";
import { mapState } from "pinia";
import OSSCorrectionProjects from "./OSSCorrection/OSSCorrectionProjects";
export default {
  name: "OSSCorrection",
  components: {
    OSSCorrectionProjects
  },
  computed: {
    ...mapState(useEnvStore, ["apiUrls"]),
  },
  methods:{
    printError(err) {
    if (this.debug) {
      this.$dp.log(err);
    }
  },
  
  }
}
</script>

<template>
  <div>
      <OSSCorrectionProjects></OSSCorrectionProjects>
  </div>
</template>

<style scoped lang="scss"></style>

<i18n>
  {
  "en-US": {
  }
  }
</i18n>
